var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-contenido"},[_c('div',{staticClass:"conjunto-titular"},[_c('p',{staticClass:"check-titular"},[_vm._v(_vm._s(_vm.titulo)+" ")])]),_c('div',{staticClass:"shapes"},_vm._l((_vm.cortes_grado),function(corte,i){return _c('div',{key:i,staticClass:"shape-item"},[_c('div',{staticClass:"shape-this-legend"},[_c('div',{staticClass:"shape circle",style:({
                  width: corte.diametro + 'px',
                  height: corte.diametro + 'px',
                  background: corte.color
              })})]),_c('div',{staticClass:"shape-text-this-legend"},[_vm._v(" "+_vm._s(corte.valor)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }